import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import { ApolloService } from '../services/apollo.service';
import { LngDataService } from './lng.service';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root',
})
export class DistributionDataService {
  constructor(private apolloService: ApolloService, private toasterService: ToasterService,private lngService: LngDataService) { }

  userLoggedEmail = new BehaviorSubject<any>({});
  changeToggle = new BehaviorSubject<boolean>(false);
  changeFleet = new BehaviorSubject<boolean>(false);
  changeMonthYear = new BehaviorSubject<any>({});
  filterdScrubberListdata:any = [];
  filterdScrubberShipNames:any = [];
  filteredScrubberShipOwner:any = [];
  filteredScrubberSubPool:any = [];
  filteredScrubberVslClass:any = [];
  filterdLngListdata:any = [];
  filterdLngShipNames:any = [];
  filteredLngShipOwner:any = [];
  filteredLngSubPool:any = [];
  filteredLngVslClass:any = [];
  getMonth:number;
  getYear:number;
  selectedMonthYear: any = '';
  selectedPagetab: string = "dist";
  bunkerData = new BehaviorSubject<any>(null);
  $loadBunkerData = this.bunkerData.asObservable();

  setSelectedMonthYearVal(monthYearValue){
    this.selectedMonthYear = monthYearValue;
  }
  getSelectedMonthYearVal(){
    return this.selectedMonthYear;
  }

  setSelectedPagetabVal(selectedPagetabVal){
    this.selectedPagetab = selectedPagetabVal;
  }
  getSelectedPagetabVal(){
    return this.selectedPagetab;
  }

  getDistributionVessel(filter: any): Observable<any> {
    const query = `
      query GetDistributionVessel($filter: DistributionDataFilter) {
      getDistributionVessel(filter: $filter) {
        message
        statusCode
        success
        hasOffHireinCurrentMonth
        hasOffHireinPreviousMonth
        hasPoolPointUpdateinCurrentMonth
        hasPenaltyinPreviousMonth
        hasPenaltyinCurrentMonth
        distributionVessel{
            subpoolName
            showScrubberSavings
            showLNGSavings
            overheadCharges
            scrubberSavings
            accountingVoyage
            accountingVoyageMonthly
            scrubberSavingsMonthly
            lngSavingsYTD
            vesselsMonthlyData{
                fleet
                vslCode
                vslNumber
                vslName
                vslOwner
                vslClass
                vslCodeOwner
                subPool
                poolPoint
                month
                year
                opDays
                distAmt
                scbrSavingsAmt
                scbrSavingsAmtYTD
                revenueAmt
                opDaysYTD
                distAmtYTD
                revenueAmtYTD
                relShareYTD
                poolOut
                poolOutYTD
                poolIn
                poolInYTD
                mgmtFees
                mgmtFeesYTD
                netPoolOut
                netPoolOutYTD
                penaltyReason
                penaltyPoolpoint
                overheadAmt
                overheadAmtYTD
                commissionAmt
                commissionAmtYTD
                bunkerAmt
                bunkerYTD
                netPoolOutPerOpdaysAmtYTD
                netPoolOutPerOpdaysAmt
                grossShareInPool
                grossShareInPoolAmt
                profitSharingContrAmt
                profitSharingContrAmtYTD
                finalPayOut
                canSeeShipLevelCalculation
                isElegibleForProfitSharing
            }
            poolTotal{
                poolPoint
                revenueAmtYTD
                distAmtYTD
                opDaysYTD
                poolInYTD
                relShareYTD
                grossShareInPool
                poolOutYTD
                overheadAmtYTD
                commissionAmtYTD
                bunkerYTD
                mgmtFeesYTD
                netPoolOutYTD
                netPoolOutPerOpdaysAmtYTD
                profitSharingContrAmtYTD
                finalPayout
                revenueAmt
                distAmt
                opDays
                poolIn
                grossShareInPoolAmt
                poolOut
                overheadAmt
                commissionAmt
                bunkerAmt
                mgmtFees
                netPoolOut
                netPoolOutPerOpdaysAmt
                profitSharingContrAmt
                profitSharingContrAmtYTD
            }
        }
      }
    }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  GetDistributionVesselCalculation(filter: any): Observable<any> {
    const query = `
      query GetDistributionVesselCalculation($filter: DistributionDataFilter) {
        getDistributionVesselCalculation(filter: $filter) {
          message
          statusCode
          success
          distributionVesselCalculation{
            fleet
            vslCode
            vslNumber
            vslName
            vslOwner
            vslCodeOwner
            subPool
            poolPoint
            month        
            year
            opDays
            distAmt    
            scbrSavingsAmt
            scbrSavingsAmtYTD
            revenueAmt
            opDaysYTD
            distAmtYTD
            revenueAmtYTD
            relShareYTD
            poolOut
            poolOutYTD
            poolIn
            poolInYTD
            mgmtFees
            mgmtFeesYTD
            netPoolOut
            netPoolOutYTD
            penaltyReason
            penaltyPoolpoint
            overheadAmt
            overheadAmtYTD
            commissionAmt
            commissionAmtYTD
            bunkerAmt
            bunkerYTD
            netPoolOutPerOpdaysAmtYTD
            netPoolOutPerOpdaysAmt
            profitSharingThresholdAmt
            profitSharingRate
            profitSharingContrAmt
            profitSharingContrAmtYTD
            grossShareInPool
            grossShareInPoolAmt
            opDaysPoolPointYTDSum
            opDaysPoolPointSum
            distAmtYTDSum
            distAmtSum
            revenueAmtYTDSum
            revenueAmtSum
            finalPayOut 
            lngSavingsAmt
            lngSavingsAmtYTD
            isElegibleForProfitSharing
            subpoolsMonthlyData {
              subpoolName
              overheadCharges
              scrubberSavingsMonthly
              scrubberSavings
              accountingVoyage
              accountingVoyageMonthly
              lngSavingsYTD
            }  
            opDaysData{
              vslCode
              calendarDays
              calendarDaysMonthly
            }
            fleetsData {
              value
              commissionPercentage
              isActive
            }
            bunkerMonthlyData {
              vslCode
              BFB
              IFO
              LSF
              MGO
              LNG
              BFBMonthly
              IFOMonthly
              LSFMonthly
              MGOMonthly
              LNGMonthly
              totalBunkerFees
            }
            ownersData{
                value
                bunkerProcurementFee{
                  IFO
                  LSF
                  MGO
                  LNG
                  BFB
                }
                isStjs
                isSnaps
            }
            vessels{
              vslCode
              scrubberType
              lng
            }
          }
        }
      }
    `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getDistributionRevenue(filter: any) {
    const query = `
        query($getDistributionRevenueFilter2: DistributionRevenueFilter) {
          getDistributionRevenue(filter: $getDistributionRevenueFilter2) {
            data {
              month
              year
              totalDistribution
              totalOpdays
            }
            ytdTce
            message
            statusCode
            success
          }
        }
        `;
    return from(this.apolloService.query(query).refetch({ getDistributionRevenueFilter2: filter }));
  }

  getYearlyDistributionRevenue(filter: any) {
    const query = `
      query GetYearlyDistributionRevenue($filter: DistributionRevenueFilter) {
        getYearlyDistributionRevenue(filter: $filter) {
          success
          statusCode
          message
          ytdTce
          data {
            year
            totaldistAmtYTD
            totalOpDaysYTD
            distAmtPerYear
          }
        }
      }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getNetPooloutPerOpDayChart(filter: any){
    const query = `
      query GetDistributionNetPoolOut($filter: DistributionNetpoolOutFilter) {
        getDistributionNetPoolOut(filter: $filter) {
          success
          statusCode
          message
          ytdNetPoolOut
          data {
            month
            year
            totalOpdays
            totalnetPoolOut
          }
        }
      }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getYearlyNetPooloutPerOpDayChart(filter: any) {
    const query = `
      query GetYearlyDistributionNetPoolOut($filter: NetPoolOutFilter) {
        getYearlyDistributionNetPoolOut(filter: $filter) {
          success
          statusCode
          message
          ytdNetPoolOut
          data {
            year
            totalOpDaysYTD
            totalNetPoolOutYTD
          }
        }
      }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getDistributionLatestData(filter) {
    const query = `
        query GetLatestMonthAndYear($filter: LatestMonthAndYearFilter) {
          getLatestMonthAndYear(filter: $filter) {
            data {
              latestMonth
              latestYear
              lastMonth
              lastYear
              lastUpdatedAt
              fiscalYearStartDate
              fiscalYearEndDate
            }
            message
            statusCode
            success
          }
        }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));

  }

  getOwnerList(fleet = '') {
    const query = `
      query GetOwnersList($fleet: String) {
        getOwnersList(fleet: $fleet) {
          success
          statusCode
          message
          data {
            value
            label
            createdAt
          }
        }
      }
      `;
    return from(this.apolloService.query(query).refetch({ fleet: fleet }));
  }

  updateOpDaysYTD(input: any, month, year, fleet) {
    const query = `
          mutation updateOpDaysYtd($input: [UpdateOpDaysYtdInput!]!,$month: Int,$year: Int,$fleet: String) {
            updateOpDaysYtd(input: $input,month: $month,year: $year, fleet: $fleet) {
              success
              statusCode
              message
              opDaysYtd {
                opDaysYtdUpdated
                norUpdated
              }
            }
          }
         `;
    return this.apolloService.mutate(query, { "input": input, "month": month, "year": year, "fleet": fleet })
  }

  getDashboardFinDates(filter) {
    const query = `
          query GetDashboardFinDates($filter: LatestMonthAndYearFilter) {
            getDashboardFinDates(filter: $filter) {
              data {
                finMaxDate
                finMinDate
                lastMonth
                lastUpdatedAt
                lastYear
                latestMonth
                latestYear
                minYear
                maxYear
                fiscalYear
              }
              message
              statusCode
              success
            }
          }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getDistributionModalData(filter: any): Observable<any> {
    const query = ` 
       query GetUserDefaultSettings($filter: UserSetingFilter) {
        getUserDefaultSettings(filter: $filter) {
          data {
            email
            module
            toggleType
            columns {
              name
              value
              YTD
              monthly 
              sequence
              hidden
            }
          }
          enableReset
          success
          statusCode
          message
        }
      }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  updateDistributionModalData(input: any): Observable<any> {
    const query = `
		mutation UpsertUserSetting($input: UserInput) {
          upsertUserSetting(input: $input) {
            data {
            email
            module
            toggleType
            columns {
            name
            value
            YTD
            monthly 
            sequence
            hidden
            }
          }
            enableReset
            success
            statusCode
            message
          }
        }
      `;
    return this.apolloService.mutate(query, { input: input })
  }
  
  getOffhireEventData(filter:any): Observable<any>{
   const query = `  
   query GetOffhireEvents($filter: OffhireFilterInput!) {
    getOffhireEvents(filter: $filter) {
      message
      statusCode
      success
      data {
        serialNo
        vslCode
        vslName
        vslNumber
        fleet
        from
        to
        days
        reason
        remarks
        isRetroActiveAdjustment
      }
    }
    }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getPoolPointsEventData(filter:any): Observable<any>{
   const query = `  
   query GetPoolPointChanges($filter: PoolPointChangeFilterInput!) {
     getPoolPointChanges(filter: $filter) {
       data {
        serialNo
        effectiveDate
        effectiveEndDate
        duration
        type
        reason
        oldPoolPoint
        newPoolPoint
        penaltyPercentage
        isRetroactiveAdjustment
       }
       success
       statusCode
       message
     }
   }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getBannerDisplay(){
   const query = `  
  query GetLogicAppRunHistoryFun {
    getLogicAppRunHistoryFun{
      data {
        startTime
        status
      }
      message
      success
      statusCode
    }
  }`;
    return this.apolloService.query(query).valueChanges;
  }

  getLogData(filter:any): Observable<any>{
    const query = `  
    query GetLog ($filter: LogFilterInput!){
    getLog (filter: $filter){
      data {
        timestamp
        message
      }
      message
      success
      statusCode
    }
  }`;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  viewBunkerPrice(payload:{fleet:string,month:any,year:any}){
    this.lngService.getLngBunkerData(payload).subscribe({
      next: (res: any) => {
       let getAvgBunkerPriceData = res?.data?.getAvgBunkerPriceData?.data;
        let groupedByFiscalYear = getAvgBunkerPriceData.reduce((acc: { [key: number]: any[] }, item:any) => {
          const year = item.year;
          if (!acc[year]) {
            acc[year] = [];
          }
          acc[year].push(item);
          return acc;
        }, {});
        let groupedFiscalYear = Object.entries(groupedByFiscalYear).sort(([a],[b]) => Number(b) - Number(a));
        this.bunkerData.next({getAvgBunkerPriceData,groupedFiscalYear})

      },
      error: (error: any) => {
        this.toasterService.openToast('Error', error)
      }
    })
    
  }
 
}

